module.exports = __webpack_public_path__ + "img/arrow-pointing-to-right.29b551dc.svg";